import { FormField } from "components/form/FormField/FormField";
import { Select } from "components/ui/Select/Select";

import style from "../ReferralForm.module.css";

export const HistoryFormSection = ({ form, isProstateReferral }) => {
  return (
    <div className={style.itemWrapper}>
      <div className={style.inputGroupGrid2Columns}>
        <FormField name="historyOfPresentingComplains">
          <label className={style.addReferralFormLabel}>
            History of Presenting Complaints *
          </label>
          <textarea
            className="form-control textareaform-control"
            style={{ minHeight: "126px" }}
            {...form.register("historyOfPresentingComplains")}
          />
        </FormField>
        {!isProstateReferral && (
          <FormField name="previousHospitalAttendance">
            <label className={style.addReferralFormLabel}>
              Previous Hospital Attendance
            </label>
            <Select
              options={[
                {
                  label: "Yes",
                  value: "true",
                },
                {
                  label: "No",
                  value: "false",
                },
              ]}
              value={form.watch("previousHospitalAttendance")}
              fullWidth
              onChange={(value) =>
                form.setValue("previousHospitalAttendance", value)
              }
              required
            />
          </FormField>
        )}
        <FormField name="historyOfPastIllness">
          <label className={style.addReferralFormLabel}>
            History of Past Illness
          </label>
          <textarea
            className="form-control textareaform-control"
            style={{ minHeight: "126px" }}
            {...form.register("historyOfPastIllness")}
          />
        </FormField>
        <FormField name="historyOfSurgicalProcedures">
          <label className={style.addReferralFormLabel}>
            History of Surgical Procedures
          </label>
          <textarea
            className="form-control textareaform-control"
            style={{ minHeight: "126px" }}
            {...form.register("historyOfSurgicalProcedures")}
          />
        </FormField>
        <FormField name="allergiesAdverseMedicationEvents">
          <label className={style.addReferralFormLabel}>
            Allergies / Adverse Medication Events
          </label>
          <textarea
            className="form-control textareaform-control"
            style={{ minHeight: "126px" }}
            {...form.register("allergiesAdverseMedicationEvents")}
          />
        </FormField>
        <FormField name="relevantFamilyHistory">
          <label className={style.addReferralFormLabel}>
            Relevant Family History
          </label>
          <textarea
            className="form-control textareaform-control"
            style={{ minHeight: "126px" }}
            {...form.register("relevantFamilyHistory")}
          />
        </FormField>
      </div>
    </div>
  );
};
